import { render } from "./menu_master.vue?vue&type=template&id=4e7808c8&scoped=true"
import script from "./menu_master.vue?vue&type=script&lang=js"
export * from "./menu_master.vue?vue&type=script&lang=js"

import "./menu_master.vue?vue&type=style&index=0&id=4e7808c8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7808c8"]])

export default __exports__